import mixpanel from "mixpanel-browser";
import type { TrackedUser, Tracker, TrackerEvent, TrackerEventData } from "types";

// Initializes Mixpanel client with token and options
export const initMixpanel = (): typeof mixpanel | null => {
    try {
        mixpanel.init(import.meta.env.REACT_APP_MIXPANEL_TOKEN!, {
            debug: !!import.meta.env.DEV,
            track_pageview: false,
            autocapture: false,
            persistence: "localStorage",
        });

        return mixpanel;
    } catch (e) {
        console.error("[tracker] Mixpanel init error", e);
        return null;
    }
};

// Factory function for creating a Mixpanel tracker implementing the Tracker interface
// expected by the TrackerContext
export const makeMixPanelTracker = (m: typeof mixpanel): Tracker => {
    return {
        trackEvent: async <T extends TrackerEvent>(event: T, data: TrackerEventData<T>) => {
            m.track(event, data);
        },
        registerSession: async (user: TrackedUser) => {
            m.identify(user.username);
            m.people.set({
                $name: user.name,
                $email: user.email,
                companyId: user.companyId,
                companyName: user.companyName,
                accountType: user.accountType,
            });
        },
        unregisterSession: async () => {
            m.reset();
        },
    };
};
